import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const TriangleExclamationSolid = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon width={18} height={16} {...other}>
			<path
				d="M8.99943 0.125C9.49865 0.125 9.9592 0.388672 10.2123 0.821094L17.8061 13.7586C18.0627 14.1945 18.0627 14.7324 17.8131 15.1684C17.5635 15.6043 17.0959 15.875 16.5932 15.875H1.40568C0.90295 15.875 0.435372 15.6043 0.185763 15.1684C-0.0638464 14.7324 -0.0603308 14.191 0.192794 13.7586L7.78654 0.821094C8.03967 0.388672 8.50022 0.125 8.99943 0.125ZM8.99943 4.625C8.53186 4.625 8.15568 5.00117 8.15568 5.46875V9.40625C8.15568 9.87383 8.53186 10.25 8.99943 10.25C9.46701 10.25 9.84319 9.87383 9.84319 9.40625V5.46875C9.84319 5.00117 9.46701 4.625 8.99943 4.625ZM10.1244 12.5C10.1244 11.8777 9.6217 11.375 8.99943 11.375C8.37717 11.375 7.87443 11.8777 7.87443 12.5C7.87443 13.1223 8.37717 13.625 8.99943 13.625C9.6217 13.625 10.1244 13.1223 10.1244 12.5Z"
				id="TriangleExclamationSolid"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

TriangleExclamationSolid.propTypes = {
	color: PropTypes.string,
};

export default TriangleExclamationSolid;
